<p-sidebar [(visible)]="showExportSidebar"
		   [position]="'right'"
		   [baseZIndex]="10000"
		   (onHide)="changedVisibleExportSidebar(false)"
		   [style]="{width:'580px'}">
	<ng-template pTemplate="header">Export data</ng-template>

	<div class="flex flex-column mt-2">
		<label class="export-data-label mb-2">File Type</label>
		<p-dropdown [options]="ExportFileTypeModel.ExportFileTypes" placeholder="Please Select" optionLabel="name"
					optionValue="value" [(ngModel)]="exportData.fileType"></p-dropdown>
	</div>
	<div class="flex justify-content-end mt-4" *ngIf="!exportLoading">
		<button class="btn-darkblue" pButton label="Download" (click)="exportTransactions()"></button>
	</div>
</p-sidebar>

<p-dialog
		[modal]="true"
		[closable]="false"
		[draggable]="false"
		[resizable]="false"
		[(visible)]="exportLoading"
		[style]="{ width: '425px', height: '215px' }">
	<ng-template pTemplate="header">
		<span class="dialog-header">Downloading data</span>
	</ng-template>
	<ng-template pTemplate="body">
		<div class="dialog-txt text-small-normal" style="margin-top: -13px">Please wait while we preparing the data
		</div>
		<div class="mt-4 spinner"></div>
	</ng-template>
</p-dialog>

<div class="root-body"
	 [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

	<p-toast position="top-right"></p-toast>

	<!--    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>-->

	<div class="report-revenue-top-panel">
		<div class="report-revenue-title">{{tableHeader}}</div>
		<span *ngIf="isWalletReport() && revenueAmounts.walletAmount !== ''"
			  style="margin-left: 10px; font-weight: 500; font-size: 1.2rem; color: #555;">
            (Total: &#8369; {{revenueAmounts.walletAmount}})
        </span>
		<div class="flex-row">
			<p-calendar [(ngModel)]="filterObj.startDate" class="mr-4" dateFormat="'From': dd-M-yy" placeholder="From:"
						[maxDate]="filterObj.endDate" (ngModelChange)="onChangeHeaderFilterDropDown()"></p-calendar>

			<p-calendar [(ngModel)]="filterObj.endDate" class="mr-4" dateFormat="'To': dd-M-yy" placeholder="To:"
						[minDate]="filterObj.startDate" (ngModelChange)="onChangeHeaderFilterDropDown()"></p-calendar>
			<div *ngIf="!isLGUAdmin">
				<img class="btn-icon" src="Content/xpress-app/images/operator/signup/upload_files.svg" alt=''
					 height="14" width="14">
				<div pRipple class="btn-revenue-export" (click)="showSidebar()">Export Data</div>
			</div>
		</div>
	</div>

	<ng-container *ngIf="isRevenueReport()">
		<div class="cards">
			<div class="info-card mr-4" [ngClass]="{'active': activeCard === FinanceCardEnum.Booking}"
				 (click)="onFinanceCardClick(FinanceMenuEnum.Revenue)">
				<div class="card-header">Booking Amount</div>
				<div class="card-amount">&#8369;{{revenueAmounts.bookingAmount}}</div>
				<div class="card-last-update">Last updated {{revenueAmounts.bookingLastUpdate}}</div>
			</div>
			<div class="info-card mr-4" [ngClass]="{'active': activeCard === FinanceCardEnum.TopUp}"
				 (click)="onFinanceCardClick(FinanceMenuEnum.TopUps)">
				<div class="card-header">Top Up</div>
				<div class="card-amount">&#8369;{{revenueAmounts.topUpAmount}}</div>
				<div class="card-last-update">Last updated {{revenueAmounts.topUpLastUpdate}}</div>
			</div>
			<div class="info-card mr-4" [ngClass]="{'active': activeCard === FinanceCardEnum.CashOut}"
				 (click)="onFinanceCardClick(FinanceMenuEnum.CashOut)">
				<div class="card-header">Cash Out</div>
				<div class="card-amount">&#8369;{{revenueAmounts.cashOutAmount}}</div>
				<div class="card-last-update">Last updated {{revenueAmounts.cashOutLastUpdate}}</div>
			</div>
			<div class="info-card" style="opacity: 0.6;"
				 [ngClass]="{'active': activeCard === FinanceCardEnum.WalletBalance}">
				<div class="card-header">Wallet Balance</div>
				<div class="card-amount">&#8369;{{revenueAmounts.walletAmount}}</div>
				<div class="card-last-update">Last updated {{revenueAmounts.walletLastUpdate}}</div>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="isCollectionReport()">
		<p-tabMenu class="mb-5 uppercase" [model]="menuTabItems" [activeItem]="activeTabItem"></p-tabMenu>
		<div class="mb-3"></div>
	</ng-container>

	<div class="card">
		<p-table [columns]="this.selectedColumns"
				 [value]="transactions"
				 [lazy]="true"
				 responsiveLayout="auto"
				 selectionMode="single"
				 dataKey="TransactionId"
				 (onLazyLoad)="handleLazyLoad($event)"
				 [selection]="selectedTransaction"
				 (selectionChange)="onSelectionChange($event)"
				 [paginator]="true"
				 [(first)]="first"
				 [rows]="rowsPerPage"
				 [showFirstLastIcon]="false"
				 [totalRecords]="totalRecords"
				 [resizableColumns]="true"
				 [columnResizeMode]="'expand'"
				 [styleClass]="'p-datatable-gridlines'"
				 [scrollable]="true"
				 [autoLayout]="true"
				 [loading]="loading"
				 [scrollHeight]="'flex'">
			<ng-template pTemplate="caption">
				<div class="onboarding-head">
					<div class="onboarding-head-fleft">
						<div class="onboarding-head-title">
							{{tableDataHeader}}
						</div>
					</div>
					<div class="flex flex-row onboarding-head-right">
						<div class="ml-5 mt-2 mr-2">
							<column-selector #columnSelector
											 [defaultColumns]="defaultCols"
											 (selectedColumnsChange)="onSelectedColumnsChange($event)"
											 [tableName]="tableName"
											 [(selectedColumns)]="cols">
							</column-selector>
						</div>
					</div>
				</div>
			</ng-template>
			<ng-template pTemplate="header">
				<tr>
					<th *ngFor="let col of this.selectedColumns"
						[pSortableColumn]="col.field"
						pResizableColumn
						[style.width]="col.width">
						{{col.header}}
						<p-sortIcon class="transactions-column-sorticon" [field]="col.field"></p-sortIcon>
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-transaction let-columns="columns">				
				<tr [ngStyle]="{'cursor': isWalletReport() ? 'default' : 'pointer'}">					
					<td *ngFor="let col of columns"
						[pSelectableRow]="isWalletReport() ? null : transaction"
						(click)="handleShowTransactionInfo(transaction)">

						<ng-container [ngSwitch]="col.field">
							<ng-container *ngSwitchCase="'DriverTags'">
                    <span [ngClass]="{'non-regular': transaction.DriverTags !== 'Regular'}" class="driver-tag"
						  (click)="removeDriverTag(transaction)">
                        {{ transaction[col.field] }}
                    </span>
							</ng-container>
							<ng-container *ngSwitchDefault>
								{{ transaction[col.field] }}
							</ng-container>
						</ng-container>
					</td>
				</tr>
			</ng-template>
			<ng-template pTemplate="paginatorleft" let-state>
				<div *ngIf="homeTransactionItems.Items.length > 0" style="padding-left: 10px">
					Showing {{first + 1}} to {{first + homeTransactionItems.Items.length}} of {{totalRecords}} entries
				</div>
			</ng-template>
		</p-table>
		<img *ngIf="(!homeTransactionItems.Items || homeTransactionItems.Items.length === 0) && !loading"
			 class="no-entries" src="Content/xpress-app/images/no-entries.jpg" alt=''>
	</div>
</div>

<home-transaction-details *ngIf="showDetailTransactionSidebar"
						  [showTransactionsSidebar]="showDetailTransactionSidebar"
						  (updateTransactionsEmit)="updateEventEmit($event)"
						  [_transactionId]="selectedTransaction?.TransactionId">
</home-transaction-details>
